import { useStaticQuery, graphql } from "gatsby"

const caseStudiesQuery = graphql`
  query CaseStudiesQuery {
    cases: allCraftCaseStudiesDefaultEntry {
      nodes {
        ...caseStudiesDefaultSummary
      }
    }
  }
`
export const useCaseStudiesEntries = () => {
  const { cases } = useStaticQuery(caseStudiesQuery)

  return cases?.nodes
}
